import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getMainPageSlice, setMainPageSection, setMainPagePeriod } from '@store/features/filters/MainPageSlice/MainPageSlice';
import { DATE_FORMAT } from '@constants/index';
import moment from 'moment-timezone';

export const useUpdateSection = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { startDate } = useSelector(getMainPageSlice);

  const updateMainPageSection = useCallback(
    (sectionId) => {
      window.scrollTo(0, 0);
      dispatch(setMainPageSection(sectionId));
      searchParams.set('section', sectionId);
      setSearchParams(searchParams);
    },
    [searchParams]
  );

  const updateSearchPeriod = useCallback(
    (rig) => {
      if (rig?.lowerLimit)
      {
        let rigLowerLimitDate = moment(rig.lowerLimit);
        if(moment(startDate).isBefore(rigLowerLimitDate)) {
          let newEndDate = moment();
          let newStartDate = moment().subtract(14, 'days');
          newStartDate = 
            newStartDate.isBefore(rigLowerLimitDate)
              ? rigLowerLimitDate
              : newStartDate;
              
          dispatch(
            setMainPagePeriod({
              startDate: newStartDate.format(DATE_FORMAT),
              endDate: newEndDate.format(DATE_FORMAT)
            })
          );
        }
      }
    },
    [startDate, dispatch]
  );

  return { updateMainPageSection, updateSearchPeriod };
};
